/* tslint:disable */
/* eslint-disable */
/**
 * leverup Service Application
 * Documentation for your application APIs v1.0
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  LatestPairPricesRequest,
  LatestPairPricesResponse,
  OracleBatchPriceResponse,
  PairHoursAgoPriceResponse,
  PositionOraclePriceRequest,
  PositionOraclePythComparisonRequest,
  PythOracleComparisonResponse,
} from '../models/index';

export interface ComparePythCoreAndProByPositionRequest {
    positionOraclePythComparisonRequest: PositionOraclePythComparisonRequest;
}

export interface GetLatestPairPricesRequest {
    latestPairPricesRequest: LatestPairPricesRequest;
}

export interface GetPair24hAgoPriceRequest {
    pairBase: string;
    blockChain: GetPair24hAgoPriceBlockChainEnum;
}

export interface GetPairHoursAgoPriceRequest {
    pairBase: string;
    blockChain: GetPairHoursAgoPriceBlockChainEnum;
    hoursAgo?: number;
}

export interface GetPriceUpdatesByPositionRequest {
    positionOraclePriceRequest: PositionOraclePriceRequest;
}

/**
 * 
 */
export class OraclePriceControllerApi extends runtime.BaseAPI {

    /**
     */
    async comparePythCoreAndProByPositionRaw(requestParameters: ComparePythCoreAndProByPositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PythOracleComparisonResponse>> {
        if (requestParameters['positionOraclePythComparisonRequest'] == null) {
            throw new runtime.RequiredError(
                'positionOraclePythComparisonRequest',
                'Required parameter "positionOraclePythComparisonRequest" was null or undefined when calling comparePythCoreAndProByPosition().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/oracle/price/updates/by-position/pyth-compare`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['positionOraclePythComparisonRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async comparePythCoreAndProByPosition(requestParameters: ComparePythCoreAndProByPositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PythOracleComparisonResponse> {
        const response = await this.comparePythCoreAndProByPositionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLatestPairPricesRaw(requestParameters: GetLatestPairPricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LatestPairPricesResponse>> {
        if (requestParameters['latestPairPricesRequest'] == null) {
            throw new runtime.RequiredError(
                'latestPairPricesRequest',
                'Required parameter "latestPairPricesRequest" was null or undefined when calling getLatestPairPrices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/oracle/price/pairs/latest`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['latestPairPricesRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getLatestPairPrices(requestParameters: GetLatestPairPricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LatestPairPricesResponse> {
        const response = await this.getLatestPairPricesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPair24hAgoPriceRaw(requestParameters: GetPair24hAgoPriceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PairHoursAgoPriceResponse>> {
        if (requestParameters['pairBase'] == null) {
            throw new runtime.RequiredError(
                'pairBase',
                'Required parameter "pairBase" was null or undefined when calling getPair24hAgoPrice().'
            );
        }

        if (requestParameters['blockChain'] == null) {
            throw new runtime.RequiredError(
                'blockChain',
                'Required parameter "blockChain" was null or undefined when calling getPair24hAgoPrice().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pairBase'] != null) {
            queryParameters['pair_base'] = requestParameters['pairBase'];
        }

        if (requestParameters['blockChain'] != null) {
            queryParameters['block_chain'] = requestParameters['blockChain'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/oracle/price/pair-24h-ago`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getPair24hAgoPrice(requestParameters: GetPair24hAgoPriceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PairHoursAgoPriceResponse> {
        const response = await this.getPair24hAgoPriceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPairHoursAgoPriceRaw(requestParameters: GetPairHoursAgoPriceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PairHoursAgoPriceResponse>> {
        if (requestParameters['pairBase'] == null) {
            throw new runtime.RequiredError(
                'pairBase',
                'Required parameter "pairBase" was null or undefined when calling getPairHoursAgoPrice().'
            );
        }

        if (requestParameters['blockChain'] == null) {
            throw new runtime.RequiredError(
                'blockChain',
                'Required parameter "blockChain" was null or undefined when calling getPairHoursAgoPrice().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pairBase'] != null) {
            queryParameters['pair_base'] = requestParameters['pairBase'];
        }

        if (requestParameters['hoursAgo'] != null) {
            queryParameters['hours_ago'] = requestParameters['hoursAgo'];
        }

        if (requestParameters['blockChain'] != null) {
            queryParameters['block_chain'] = requestParameters['blockChain'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/oracle/price/pair-hours-ago`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getPairHoursAgoPrice(requestParameters: GetPairHoursAgoPriceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PairHoursAgoPriceResponse> {
        const response = await this.getPairHoursAgoPriceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPriceUpdatesByPositionRaw(requestParameters: GetPriceUpdatesByPositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OracleBatchPriceResponse>> {
        if (requestParameters['positionOraclePriceRequest'] == null) {
            throw new runtime.RequiredError(
                'positionOraclePriceRequest',
                'Required parameter "positionOraclePriceRequest" was null or undefined when calling getPriceUpdatesByPosition().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/oracle/price/updates/by-position`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['positionOraclePriceRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getPriceUpdatesByPosition(requestParameters: GetPriceUpdatesByPositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OracleBatchPriceResponse> {
        const response = await this.getPriceUpdatesByPositionRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum GetPair24hAgoPriceBlockChainEnum {
    Monad = 'MONAD'
}
/**
  * @export
  * @enum {string}
  */
export enum GetPairHoursAgoPriceBlockChainEnum {
    Monad = 'MONAD'
}
